var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "tdMapChainFilterListBrand",
      class: { selected: _vm.brand.selected },
      attrs: { href: "#" },
      on: {
        click: function ($event) {
          return _vm.toggleSelection($event)
        },
      },
    },
    [
      _c("i", { staticClass: "material-icons" }, [_vm._v(_vm._s(_vm.icon))]),
      _c("span", [_vm._v(_vm._s(_vm.brand.name))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }